import ActivationStep from './ActivationStep';
import ProfileStep from './ProfileStep';
import PassportStep from './PassportStep';
import AddressStep from './AddressStep';
import VehicleStep from './VehicleStep';
import Login from '../../Login';
import SigningStep from './SigningStep';

export { ActivationStep, Login, ProfileStep, PassportStep, AddressStep, VehicleStep, SigningStep };



// WEBPACK FOOTER //
// ./src/components/Auth/Registration/Steps/index.js